// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Alert,
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Chip,
//   CircularProgress,
//   Container,
//   Grid,
//   Snackbar,
//   Stack,
//   Typography,
// } from "@mui/material";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import { useNavigate } from "react-router-dom";
// import ApiServices from "../../Utils/ApiServices";

// const API_BASE = `/api/v1`;

// const getAccessToken = () => localStorage.getItem("access_token") || "";
// const getCustomerId = () =>
//   localStorage.getItem("customer_id") ||
//   localStorage.getItem("customerId") ||
//   localStorage.getItem("logged_customer_id") ||
//   localStorage.getItem("user_id") ||
//   "";

// const getAuthConfig = () => ({

//     Authorization: `Bearer ${getAccessToken()}`,

// });

// const getStatusColor = (status) => {
//   const map = {
//     pending: "warning",
//     accepted: "info",
//     preparing: "secondary",
//     ready: "success",
//     completed: "success",
//     cancelled: "error",
//   };
//   return map[status] || "default";
// };

// const formatDateTime = (value) => {
//   if (!value) return "—";
//   return new Date(value).toLocaleString();
// };

// const OrdersPage = () => {
//   const navigate = useNavigate();
//   const isLoggedIn = localStorage.getItem("is_logged") === "true";
//   const customerId = useMemo(() => getCustomerId(), []);

//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });

//   const fetchOrders = async () => {
//     if (!isLoggedIn || !customerId) {
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await ApiServices.get(
//         `/api/v1/customers/${customerId}/orders/`,
//         getAuthConfig()
//       );
//       setOrders(Array.isArray(response?.data) ? response.data : []);
//     } catch (error) {
//       setSnackbar({
//         open: true,
//         message: error?.response?.data?.detail || "Failed to load orders.",
//         severity: "error",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   return (
//     <Box sx={{ minHeight: "100vh", bgcolor: "#f8fafc", py: 5 }}>
//       <Container maxWidth="lg">
//         <Stack spacing={3}>
//           <Box>
//             <Typography variant="h4" fontWeight={800}>
//               My Orders
//             </Typography>
//             <Typography color="text.secondary">
//               Track placed orders, live statuses, and details.
//             </Typography>
//           </Box>

//           {!isLoggedIn ? (
//             <Alert severity="warning" sx={{ borderRadius: 3 }}>
//               Please login to view your orders.
//             </Alert>
//           ) : loading ? (
//             <Box
//               sx={{
//                 minHeight: 300,
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <CircularProgress />
//             </Box>
//           ) : orders.length === 0 ? (
//             <Alert severity="info" sx={{ borderRadius: 3 }}>
//               No orders found yet.
//             </Alert>
//           ) : (
//             <Grid container spacing={3}>
//               {orders.map((order) => (
//                 <Grid item xs={12} md={6} key={order.id}>
//                   <Card
//                     sx={{
//                       borderRadius: 4,
//                       border: "1px solid rgba(0,0,0,0.06)",
//                       boxShadow: "0 10px 24px rgba(15,23,42,0.06)",
//                     }}
//                   >
//                     <CardContent sx={{ p: 3 }}>
//                       <Stack spacing={2}>
//                         <Stack
//                           direction="row"
//                           justifyContent="space-between"
//                           alignItems="flex-start"
//                         >
//                           <Box>
//                             <Typography variant="h6" fontWeight={800}>
//                               {order.order_number}
//                             </Typography>
//                             <Typography
//                               variant="body2"
//                               color="text.secondary"
//                               sx={{ mt: 0.5 }}
//                             >
//                               {formatDateTime(order.placed_at)}
//                             </Typography>
//                           </Box>

//                           <Chip
//                             label={order.status}
//                             color={getStatusColor(order.status)}
//                             sx={{ textTransform: "capitalize", fontWeight: 700 }}
//                           />
//                         </Stack>

//                         <Stack direction="row" spacing={1} flexWrap="wrap">
//                           <Chip
//                             icon={<ReceiptLongIcon />}
//                             label={`${order.items?.length || 0} item(s)`}
//                           />
//                           <Chip
//                             icon={<AccessTimeIcon />}
//                             label={`${order.prep_time_minutes || 0} min`}
//                           />
//                           <Chip
//                             label={order.service_type}
//                             sx={{ textTransform: "capitalize" }}
//                           />
//                         </Stack>

//                         <Typography variant="body2" color="text.secondary">
//                           Total: <strong>₹{Number(order.total || 0).toFixed(2)}</strong>
//                         </Typography>

//                         <Button
//                           variant="contained"
//                           endIcon={<ArrowForwardIcon />}
//                           onClick={() => navigate(`/orders/${order.id}`)}
//                           sx={{
//                             alignSelf: "flex-start",
//                             borderRadius: 3,
//                             background:
//                               "linear-gradient(90deg, #f97316 0%, #ea580c 100%)",
//                           }}
//                         >
//                           View Details
//                         </Button>
//                       </Stack>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>
//           )}
//         </Stack>
//       </Container>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3500}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           variant="filled"
//           severity={snackbar.severity}
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default OrdersPage;


import React, { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Snackbar,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import ApiServices from "../../Utils/ApiServices";

const API_BASE = `/api/v1`;

const getAccessToken = () => localStorage.getItem("access_token") || "";
const getCustomerId = () =>
  localStorage.getItem("customer_id") ||
  localStorage.getItem("customerId") ||
  localStorage.getItem("logged_customer_id") ||
  localStorage.getItem("user_id") ||
  "";

const getAuthConfig = () => ({
  Authorization: `Bearer ${getAccessToken()}`,
});

// foodie status palette
const STATUS_STYLES = {
  pending:   { bg: "linear-gradient(135deg,#FFB300,#FF8F00)", color: "#fff", label: "Pending" },
  accepted:  { bg: "linear-gradient(135deg,#42A5F5,#1E88E5)", color: "#fff", label: "Accepted" },
  preparing: { bg: "linear-gradient(135deg,#AB47BC,#7B1FA2)", color: "#fff", label: "Preparing" },
  ready:     { bg: "linear-gradient(135deg,#66BB6A,#2E7D32)", color: "#fff", label: "Ready" },
  completed: { bg: "linear-gradient(135deg,#26A69A,#00695C)", color: "#fff", label: "Completed" },
  cancelled: { bg: "linear-gradient(135deg,#EF5350,#C62828)", color: "#fff", label: "Cancelled" },
};
const getStatusStyle = (s) =>
  STATUS_STYLES[s] || { bg: "linear-gradient(135deg,#9E9E9E,#616161)", color: "#fff", label: s || "—" };

const formatDateTime = (value) => {
  if (!value) return "—";
  return new Date(value).toLocaleString();
};

const BG = "linear-gradient(135deg,#FFF8F0 0%,#FFEFE0 50%,#FFE0CC 100%)";
const REDGRAD = "linear-gradient(135deg,#7A0E0E 0%,#B71C1C 50%,#E64A19 100%)";
const AMBERGRAD = "linear-gradient(135deg,#FF8F00 0%,#FFB300 50%,#FFC107 100%)";

const OrdersPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLoggedIn = localStorage.getItem("is_logged") === "true";
  const customerId = useMemo(() => getCustomerId(), []);

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const fetchOrders = async () => {
    if (!isLoggedIn || !customerId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await ApiServices.get(
        `/api/v1/customers/${customerId}/orders/`,
        getAuthConfig()
      );
      setOrders(Array.isArray(response?.data) ? response.data : []);
    } catch (error) {
      setSnackbar({
        open: true,
        message: error?.response?.data?.detail || "Failed to load orders.",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: BG,
        position: "relative",
        overflow: "hidden",
        py: { xs: 3, sm: 5, md: 7 },
      }}
    >
      {/* ambient floating blobs */}
      <Box
        sx={{
          position: "absolute",
          top: -120,
          left: -100,
          width: 380,
          height: 380,
          borderRadius: "50%",
          background: "radial-gradient(circle,rgba(230,74,25,0.25),transparent 70%)",
          filter: "blur(40px)",
          animation: "op-float-1 14s ease-in-out infinite",
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: -140,
          right: -120,
          width: 420,
          height: 420,
          borderRadius: "50%",
          background: "radial-gradient(circle,rgba(255,179,0,0.22),transparent 70%)",
          filter: "blur(50px)",
          animation: "op-float-2 18s ease-in-out infinite",
          pointerEvents: "none",
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1, px: { xs: 2, sm: 3 } }}>
        <Stack spacing={{ xs: 3, md: 4 }}>
          {/* Hero header */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <Card
              sx={{
                borderRadius: { xs: 4, md: 6 },
                background: REDGRAD,
                color: "#fff",
                position: "relative",
                overflow: "hidden",
                boxShadow: "0 20px 60px rgba(122,14,14,0.35)",
              }}
            >
              {/* shimmer */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(90deg,transparent,rgba(255,255,255,0.15),transparent)",
                  backgroundSize: "200% 100%",
                  animation: "op-shimmer 6s linear infinite",
                  pointerEvents: "none",
                }}
              />
              <CardContent sx={{ p: { xs: 3, sm: 4, md: 5 }, position: "relative" }}>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={{ xs: 2, sm: 3 }}
                  alignItems={{ xs: "flex-start", sm: "center" }}
                >
                  <Avatar
                    sx={{
                      width: { xs: 56, sm: 72 },
                      height: { xs: 56, sm: 72 },
                      background: AMBERGRAD,
                      boxShadow: "0 10px 30px rgba(255,143,0,0.5)",
                    }}
                  >
                    <ReceiptLongIcon sx={{ fontSize: { xs: 28, sm: 36 } }} />
                  </Avatar>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontFamily: "'Playfair Display',serif",
                        fontWeight: 800,
                        fontSize: { xs: 28, sm: 36, md: 44 },
                        lineHeight: 1.1,
                        letterSpacing: "-0.5px",
                      }}
                    >
                      My Orders
                    </Typography>
                    <Typography
                      sx={{
                        mt: 0.5,
                        opacity: 0.9,
                        fontSize: { xs: 13, sm: 15 },
                        fontWeight: 500,
                      }}
                    >
                      Track placed orders, live statuses & details — served fresh.
                    </Typography>
                  </Box>
                  {isLoggedIn && !loading && orders.length > 0 && (
                    <Chip
                      icon={<LocalDiningIcon sx={{ color: "#fff !important" }} />}
                      label={`${orders.length} order${orders.length > 1 ? "s" : ""}`}
                      sx={{
                        bgcolor: "rgba(255,255,255,0.2)",
                        color: "#fff",
                        fontWeight: 700,
                        backdropFilter: "blur(10px)",
                        border: "1px solid rgba(255,255,255,0.3)",
                        px: 1,
                      }}
                    />
                  )}
                </Stack>
              </CardContent>
            </Card>
          </motion.div>

          {/* Body */}
          {!isLoggedIn ? (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Card
                sx={{
                  borderRadius: 4,
                  p: { xs: 4, sm: 6 },
                  textAlign: "center",
                  background: "rgba(255,255,255,0.7)",
                  backdropFilter: "blur(20px)",
                  border: "1px solid rgba(183,28,28,0.1)",
                  boxShadow: "0 20px 50px rgba(122,14,14,0.1)",
                }}
              >
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    mx: "auto",
                    mb: 2,
                    background: AMBERGRAD,
                    boxShadow: "0 12px 30px rgba(255,143,0,0.4)",
                  }}
                >
                  <LockOutlinedIcon sx={{ fontSize: 40 }} />
                </Avatar>
                <Typography variant="h5" fontWeight={800} sx={{ color: "#2A1810", mb: 1 }}>
                  Login Required
                </Typography>
                <Typography sx={{ color: "#6b4a3a", mb: 3 }}>
                  Sign in to view your delicious order history.
                </Typography>
                <Button
                  size="large"
                  onClick={() => navigate("/login")}
                  sx={{
                    px: 4,
                    py: 1.4,
                    borderRadius: 999,
                    background: REDGRAD,
                    color: "#fff",
                    fontWeight: 700,
                    boxShadow: "0 12px 30px rgba(183,28,28,0.35)",
                    "&:hover": { boxShadow: "0 18px 40px rgba(183,28,28,0.5)" },
                  }}
                >
                  Login Now
                </Button>
              </Card>
            </motion.div>
          ) : loading ? (
            <Box
              sx={{
                minHeight: 320,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress sx={{ color: "#B71C1C" }} size={56} thickness={4} />
              <Typography sx={{ color: "#6b4a3a", fontWeight: 600 }}>
                Cooking up your orders…
              </Typography>
            </Box>
          ) : orders.length === 0 ? (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Card
                sx={{
                  borderRadius: 4,
                  p: { xs: 4, sm: 6 },
                  textAlign: "center",
                  background: "rgba(255,255,255,0.7)",
                  backdropFilter: "blur(20px)",
                  border: "1px dashed rgba(183,28,28,0.25)",
                }}
              >
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    mx: "auto",
                    mb: 2,
                    background: "linear-gradient(135deg,#FFE0CC,#FFCDB2)",
                    color: "#B71C1C",
                  }}
                >
                  <InboxOutlinedIcon sx={{ fontSize: 40 }} />
                </Avatar>
                <Typography variant="h5" fontWeight={800} sx={{ color: "#2A1810", mb: 1 }}>
                  No orders yet
                </Typography>
                <Typography sx={{ color: "#6b4a3a", mb: 3 }}>
                  Your taste adventure starts with the first bite.
                </Typography>
                <Button
                  size="large"
                  startIcon={<RestaurantMenuIcon />}
                  onClick={() => navigate("/")}
                  sx={{
                    px: 4,
                    py: 1.4,
                    borderRadius: 999,
                    background: REDGRAD,
                    color: "#fff",
                    fontWeight: 700,
                    boxShadow: "0 12px 30px rgba(183,28,28,0.35)",
                    "&:hover": { boxShadow: "0 18px 40px rgba(183,28,28,0.5)" },
                  }}
                >
                  Browse Menu
                </Button>
              </Card>
            </motion.div>
          ) : (
            <Grid container spacing={{ xs: 2, sm: 3 }}>
              <AnimatePresence>
                {orders.map((order, idx) => {
                  const sStyle = getStatusStyle(order.status);
                  return (
                    <Grid item xs={12} md={6} key={order.id}>
                      <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.5, delay: idx * 0.06, ease: "easeOut" }}
                        whileHover={{ y: -6 }}
                      >
                        <Card
                          sx={{
                            borderRadius: 4,
                            overflow: "hidden",
                            position: "relative",
                            background: "rgba(255,255,255,0.85)",
                            backdropFilter: "blur(20px)",
                            border: "1px solid rgba(183,28,28,0.08)",
                            boxShadow: "0 14px 36px rgba(122,14,14,0.1)",
                            transition: "box-shadow 0.3s",
                            "&:hover": {
                              boxShadow: "0 24px 60px rgba(122,14,14,0.18)",
                            },
                          }}
                        >
                          {/* status accent bar */}
                          <Box sx={{ height: 5, background: sStyle.bg }} />

                          <CardContent sx={{ p: { xs: 2.5, sm: 3 } }}>
                            <Stack spacing={2}>
                              <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="flex-start"
                                spacing={1}
                              >
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                  <Typography
                                    sx={{
                                      fontFamily: "'Playfair Display',serif",
                                      fontWeight: 800,
                                      fontSize: { xs: 18, sm: 20 },
                                      color: "#2A1810",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {order.order_number}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "#8b6a5a", mt: 0.5, fontSize: { xs: 12, sm: 13 } }}
                                  >
                                    {formatDateTime(order.placed_at)}
                                  </Typography>
                                </Box>

                                <Chip
                                  label={sStyle.label}
                                  size={isMobile ? "small" : "medium"}
                                  sx={{
                                    background: sStyle.bg,
                                    color: sStyle.color,
                                    fontWeight: 700,
                                    textTransform: "capitalize",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                    flexShrink: 0,
                                  }}
                                />
                              </Stack>

                              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                                <Chip
                                  size="small"
                                  icon={<ReceiptLongIcon sx={{ color: "#B71C1C !important" }} />}
                                  label={`${order.items?.length || 0} item${
                                    (order.items?.length || 0) !== 1 ? "s" : ""
                                  }`}
                                  sx={{
                                    bgcolor: "rgba(183,28,28,0.08)",
                                    color: "#7A0E0E",
                                    fontWeight: 600,
                                    border: "1px solid rgba(183,28,28,0.15)",
                                  }}
                                />
                                <Chip
                                  size="small"
                                  icon={<AccessTimeIcon sx={{ color: "#FF8F00 !important" }} />}
                                  label={`${order.prep_time_minutes || 0} min`}
                                  sx={{
                                    bgcolor: "rgba(255,143,0,0.1)",
                                    color: "#7A4A00",
                                    fontWeight: 600,
                                    border: "1px solid rgba(255,143,0,0.2)",
                                  }}
                                />
                                <Chip
                                  size="small"
                                  icon={<LocalDiningIcon sx={{ color: "#2E7D32 !important" }} />}
                                  label={order.service_type}
                                  sx={{
                                    bgcolor: "rgba(46,125,50,0.08)",
                                    color: "#1B5E20",
                                    fontWeight: 600,
                                    textTransform: "capitalize",
                                    border: "1px solid rgba(46,125,50,0.18)",
                                  }}
                                />
                              </Stack>

                              <Divider sx={{ borderColor: "rgba(183,28,28,0.08)" }} />

                              <Stack
                                direction={{ xs: "column", sm: "row" }}
                                justifyContent="space-between"
                                alignItems={{ xs: "stretch", sm: "center" }}
                                spacing={2}
                              >
                                <Box>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "#8b6a5a",
                                      fontWeight: 600,
                                      letterSpacing: 0.5,
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    Total
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: "'Playfair Display',serif",
                                      fontWeight: 800,
                                      fontSize: { xs: 24, sm: 28 },
                                      background: REDGRAD,
                                      WebkitBackgroundClip: "text",
                                      WebkitTextFillColor: "transparent",
                                      lineHeight: 1,
                                    }}
                                  >
                                    ${Number(order.total || 0).toFixed(2)}
                                  </Typography>
                                </Box>

                                <Button
                                  fullWidth={isMobile}
                                  endIcon={<ArrowForwardIcon />}
                                  onClick={() => navigate(`/orders/${order.id}`)}
                                  sx={{
                                    px: 3,
                                    py: 1.2,
                                    borderRadius: 999,
                                    background: REDGRAD,
                                    color: "#fff",
                                    fontWeight: 700,
                                    boxShadow: "0 8px 22px rgba(183,28,28,0.3)",
                                    "&:hover": {
                                      boxShadow: "0 14px 32px rgba(183,28,28,0.45)",
                                      transform: "translateY(-1px)",
                                    },
                                    transition: "all 0.25s",
                                  }}
                                >
                                  View Details
                                </Button>
                              </Stack>
                            </Stack>
                          </CardContent>
                        </Card>
                      </motion.div>
                    </Grid>
                  );
                })}
              </AnimatePresence>
            </Grid>
          )}
        </Stack>
      </Container>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3500}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          variant="filled"
          severity={snackbar.severity}
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          sx={{ borderRadius: 3, fontWeight: 600, boxShadow: "0 12px 30px rgba(0,0,0,0.2)" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default OrdersPage;
